var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconLightModeRainbow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_23255_62173)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.7427 8.88459C18.9638 8.88459 18.3231 8.24389 18.3231 7.465C18.3231 6.68611 18.9638 6.04541 19.7427 6.04541C20.5216 6.04541 21.1623 6.68611 21.1623 7.465C21.1623 8.24389 20.5216 8.88459 19.7427 8.88459ZM12.2678 11.975C11.4889 11.975 10.8482 11.3343 10.8482 10.5554C10.8482 9.77654 11.4889 9.13584 12.2678 9.13584C13.0467 9.13584 13.6874 9.77654 13.6874 10.5554C13.6874 11.3343 13.0467 11.975 12.2678 11.975ZM27.2175 11.975C26.4386 11.975 25.7979 11.3343 25.7979 10.5554C25.7979 9.77654 26.4386 9.13584 27.2175 9.13584C27.9964 9.13584 28.6371 9.77654 28.6371 10.5554C28.6371 11.3343 27.9964 11.975 27.2175 11.975ZM19.7427 24.1357C16.401 24.1357 13.6372 21.3719 13.6372 18.0303C13.6372 14.6886 16.401 11.9248 19.7427 11.9248C23.0843 11.9248 25.8482 14.6886 25.8482 18.0303C25.8482 21.3719 23.0843 24.1357 19.7427 24.1357ZM9.1774 19.4498C8.39851 19.4498 7.75781 18.8091 7.75781 18.0303C7.75781 17.2514 8.39851 16.6107 9.1774 16.6107C9.96885 16.6107 10.6096 17.2514 10.6096 18.0303C10.6096 18.8091 9.96885 19.4498 9.1774 19.4498ZM30.3079 19.4498C29.529 19.4498 28.8883 18.8091 28.8883 18.0303C28.8883 17.2514 29.529 16.6107 30.3079 16.6107C31.0868 16.6107 31.7275 17.2514 31.7275 18.0303C31.7275 18.8091 31.0868 19.4498 30.3079 19.4498ZM27.2175 26.9247C26.4386 26.9247 25.7979 26.284 25.7979 25.5051C25.7979 24.7262 26.4386 24.0855 27.2175 24.0855C27.9964 24.0855 28.6371 24.7262 28.6371 25.5051C28.6371 26.284 27.9964 26.9247 27.2175 26.9247ZM12.2678 26.9247C11.4889 26.9247 10.8482 26.284 10.8482 25.5051C10.8482 24.7262 11.4889 24.0855 12.2678 24.0855C13.0467 24.0855 13.6874 24.7262 13.6874 25.5051C13.6874 26.284 13.0467 26.9247 12.2678 26.9247ZM19.7427 30.0151C18.9638 30.0151 18.3231 29.3744 18.3231 28.5955C18.3231 27.8041 18.9638 27.1759 19.7427 27.1759C20.5216 27.1759 21.1623 27.8041 21.1623 28.5955C21.1623 29.3744 20.5216 30.0151 19.7427 30.0151Z",
    fill: "url(#paint0_linear_23255_62173)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7427 8.88459C18.9638 8.88459 18.3231 8.24389 18.3231 7.465C18.3231 6.68611 18.9638 6.04541 19.7427 6.04541C20.5216 6.04541 21.1623 6.68611 21.1623 7.465C21.1623 8.24389 20.5216 8.88459 19.7427 8.88459ZM12.2678 11.975C11.4889 11.975 10.8482 11.3343 10.8482 10.5554C10.8482 9.77654 11.4889 9.13584 12.2678 9.13584C13.0467 9.13584 13.6874 9.77654 13.6874 10.5554C13.6874 11.3343 13.0467 11.975 12.2678 11.975ZM27.2175 11.975C26.4386 11.975 25.7979 11.3343 25.7979 10.5554C25.7979 9.77654 26.4386 9.13584 27.2175 9.13584C27.9964 9.13584 28.6371 9.77654 28.6371 10.5554C28.6371 11.3343 27.9964 11.975 27.2175 11.975ZM19.7427 24.1357C16.401 24.1357 13.6372 21.3719 13.6372 18.0303C13.6372 14.6886 16.401 11.9248 19.7427 11.9248C23.0843 11.9248 25.8482 14.6886 25.8482 18.0303C25.8482 21.3719 23.0843 24.1357 19.7427 24.1357ZM9.1774 19.4498C8.39851 19.4498 7.75781 18.8091 7.75781 18.0303C7.75781 17.2514 8.39851 16.6107 9.1774 16.6107C9.96885 16.6107 10.6096 17.2514 10.6096 18.0303C10.6096 18.8091 9.96885 19.4498 9.1774 19.4498ZM30.3079 19.4498C29.529 19.4498 28.8883 18.8091 28.8883 18.0303C28.8883 17.2514 29.529 16.6107 30.3079 16.6107C31.0868 16.6107 31.7275 17.2514 31.7275 18.0303C31.7275 18.8091 31.0868 19.4498 30.3079 19.4498ZM27.2175 26.9247C26.4386 26.9247 25.7979 26.284 25.7979 25.5051C25.7979 24.7262 26.4386 24.0855 27.2175 24.0855C27.9964 24.0855 28.6371 24.7262 28.6371 25.5051C28.6371 26.284 27.9964 26.9247 27.2175 26.9247ZM12.2678 26.9247C11.4889 26.9247 10.8482 26.284 10.8482 25.5051C10.8482 24.7262 11.4889 24.0855 12.2678 24.0855C13.0467 24.0855 13.6874 24.7262 13.6874 25.5051C13.6874 26.284 13.0467 26.9247 12.2678 26.9247ZM19.7427 30.0151C18.9638 30.0151 18.3231 29.3744 18.3231 28.5955C18.3231 27.8041 18.9638 27.1759 19.7427 27.1759C20.5216 27.1759 21.1623 27.8041 21.1623 28.5955C21.1623 29.3744 20.5216 30.0151 19.7427 30.0151Z",
    fill: "white",
    fillOpacity: 0.2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_23255_62173",
    x: -0.802831,
    y: -0.802868,
    width: 41.091,
    height: 41.091,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.71212
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.71212
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_23255_62173"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1.71212,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect2_dropShadow_23255_62173"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.71212
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.56818
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_23255_62173",
    result: "effect2_dropShadow_23255_62173"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_23255_62173",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_23255_62173",
    x1: 7.75781,
    y1: 18.0303,
    x2: 31.7275,
    y2: 18.0303,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFD62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6AE6"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLightModeRainbow);
export default __webpack_public_path__ + "static/media/icon-light-mode-rainbow.08d69299f1617c9ad48a33557eb01456.svg";
export { ForwardRef as ReactComponent };